import React from 'react';
import BottomNavItem from '@/components/BottomNavItem';
import { navigationItems } from '@/config/bottomNav';
import { BottomNavWrapper } from './styles';

export default function BottomNavigation() {
    return (
        <BottomNavWrapper>
            {navigationItems.map((item) => (
                <BottomNavItem
                    key={item.href}
                    href={item.href}
                    inactiveIcon={item.inactiveIcon}
                    activeIcon={item.activeIcon}
                    label={item.label}
                    actionName={item.actionName}
                />
            ))}
        </BottomNavWrapper>
    );
}
